import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1697fb43"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "w-100 mda-dashboard container mt-lg-5 mt-md-3" }
const _hoisted_2 = { class: "row my-2" }
const _hoisted_3 = { class: "col-lg-8" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-lg-4" }, null, -1))
const _hoisted_5 = { class: "my-2" }
const _hoisted_6 = { class: "container-fluid" }
const _hoisted_7 = { class: "p-text-center" }
const _hoisted_8 = { class: "p-text-center" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSelect = _resolveComponent("BaseSelect")!
  const _component_Column = _resolveComponent("Column")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_BaseSelect, { selectType: _ctx.programAreaProp }, null, 8, ["selectType"])
      ]),
      _hoisted_4
    ]),
    _createElementVNode("main", _hoisted_5, [
      _createElementVNode("section", _hoisted_6, [
        _createVNode(_component_DataTable, {
          responsiveLayout: "scroll",
          breakpoint: "700px",
          value: _ctx.body,
          paginator: true,
          loading: _ctx.loading,
          rows: 10,
          stripedRows: "",
          selectionMode: "single",
          columnResizeMode: "fit",
          scrollHeight: "flex",
          showGridlines: true
        }, {
          empty: _withCtx(() => [
            _createElementVNode("h6", _hoisted_7, "No " + _toDisplayString(_ctx.title) + " found.", 1)
          ]),
          loading: _withCtx(() => [
            _createElementVNode("h6", _hoisted_8, " Loading " + _toDisplayString(_ctx.title) + " data. Please wait. ", 1)
          ]),
          footer: _withCtx(() => [
            (_ctx.body.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, " In total there " + _toDisplayString(_ctx.body && _ctx.body.length === 1 ? "is" : "are") + " " + _toDisplayString(_ctx.body ? _ctx.body.length : 0) + " " + _toDisplayString(_ctx.title) + ". ", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_10))
          ]),
          default: _withCtx(() => [
            _createVNode(_component_Column, {
              field: "submitted",
              header: "Submitted Innovations",
              sortable: true,
              frozen: true
            }),
            _createVNode(_component_Column, {
              field: "innovators",
              header: "Innovators",
              sortable: true
            }),
            _createVNode(_component_Column, {
              field: "stage",
              header: "Stage"
            }),
            _createVNode(_component_Column, {
              field: "files",
              header: "Files",
              sortable: true
            }, {
              body: _withCtx((slotProps) => [
                _createElementVNode("i", {
                  class: _normalizeClass([slotProps, "bi bi-file-earmark-zip-fill file"])
                }, null, 2),
                _createTextVNode(_toDisplayString(slotProps.data.file) + "KB", 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Column, {
              field: "partners",
              header: "No. Partners",
              sortable: true
            })
          ]),
          _: 1
        }, 8, ["value", "loading"])
      ])
    ])
  ]))
}